$ = require 'jquery'
Auth = require 'db/auth'
Backgrounds = require 'data/backgrounds'
BoardDisplayHelpers = require 'views/internal/board-display-helpers'
BoardSelectOrganizationView = require 'views/board-menu/board-select-organization-view'
ChangeBoardAddMemberPermsView = require 'views/board-menu/change-board-add-member-perms-view'
ChangeBoardCommentingPermsView = require 'views/board-menu/change-board-commenting-perms-view'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
Confirm = require 'views/lib/confirm'
SharePopoverView = require 'views/board/share-popover-view'
EditEmailSettingsView = require 'views/board-menu/edit-email-settings-view'
CreateBoardView = require 'views/board/create-board-view'
WindowSize = require 'lib/window-size'
_ = require 'underscore'
t = require('views/internal/teacup-with-helpers')('board_menu_settings_and_more')
track = require 'debug/track'
l = require 'lib/localize'

template = t.renderable ({
  canChangeAddMembers
  canChangeBackground
  canChangeCardCovers
  canChangeComments
  canChangeOrg
  canChangeSelfJoin
  canClose
  canEmailToBoard
  canLeave
  canRemoveOrg
  cardCovers
  commentsDisplay
  editable
  hasOrg
  helperText
  invitationsDisplay
  isPrivate
  loggedIn
  orgDisplayName
  pLevelAltText
  pLevelClass
  selfJoin
  shortUrl
}) ->
  t.div ->
    t.ul '.board-menu-navigation', ->

      if canChangeBackground
        t.li '.board-menu-navigation-item.mod-background', ->
          t.a '.board-menu-navigation-item-link.js-change-background', { href: '#' }, ->
            t.span '.board-menu-navigation-item-link-icon.js-fill-background-preview'
            t.format 'change-background'

      t.li '.board-menu-navigation-item', ->
        t.a '.board-menu-navigation-item-link.js-open-labels', { href: '#' }, ->
          t.icon 'label', { class: 'board-menu-navigation-item-link-icon' }
          t.format 'labels'

      t.li '.board-menu-navigation-item', ->
        t.a '.board-menu-navigation-item-link.js-open-collections', { href: '#' }, ->
          t.img '.board-menu-navigation-item-link-icon.collection-icon-img', { src: require('images/collections/collections-grey.svg') }
          t.format 'collections'

      t.li '.board-menu-navigation-item', ->
        t.a '.board-menu-navigation-item-link.js-open-archive', { href: '#' }, ->
          t.icon 'archive', { class: 'board-menu-navigation-item-link-icon' }
          t.format 'archived-items'

    t.hr()

    t.ul '.board-menu-navigation', ->

      if canEmailToBoard
        t.li '.board-menu-navigation-item', ->
          t.a '.board-menu-navigation-item-link.js-email', { href: '#' }, ->
            t.icon 'email', { class: 'board-menu-navigation-item-link-icon' }
            t.format 'email-to-board-settings'

      if loggedIn
        t.li '.board-menu-navigation-item', ->
          t.a '.board-menu-navigation-item-link.js-copy-board', { href: '#' }, ->
            t.icon 'board', { class: 'board-menu-navigation-item-link-icon' }
            t.format 'copy-board'

      t.li '.board-menu-navigation-item', ->
        t.a '.board-menu-navigation-item-link.js-share', { href: '#' }, ->
          t.icon 'share', { class: 'board-menu-navigation-item-link-icon' }
          t.format 'print-and-export'

    t.hr()

  t.ul '.board-menu-navigation', ->

    t.li '.board-menu-navigation-item', ->
      t.a '.board-menu-navigation-item-link', { class: t.classify({
        'js-change-org': canChangeOrg || canRemoveOrg
        'disabled': !(canChangeOrg || canRemoveOrg)
      }), href: '#' }, ->
        if canRemoveOrg
          t.format 'remove-from-organization'
        else
          t.format 'change-organization-ellipsis'
        if orgDisplayName
          t.span '.sub-name', ->
            t.text orgDisplayName

    t.hr()

    t.li '.board-menu-navigation-item', ->
      t.a '.board-menu-navigation-item-link', { class: t.classify({
        'js-toggle-covers': canChangeCardCovers
        'disabled': !canChangeCardCovers
      }) }, ->
        if cardCovers
          t.format 'card-cover-images-enabled'
          t.icon 'check'
        else
          t.format 'enable-card-cover-images'
        t.span '.sub-name', ->
          t.format 'show-images-on-front-of-cards'

    t.hr()

    t.li '.board-menu-navigation-item', ->
      t.a '.board-menu-navigation-item-link', { class: t.classify({
        'js-change-comments': canChangeComments
        'disabled': !canChangeComments
      }) }, ->
        t.format 'commenting-permissions-ellipsis-commentsdisplay', { commentsDisplay }

    t.li '.board-menu-navigation-item', ->
      t.a '.board-menu-navigation-item-link', { class: t.classify({
        'js-change-add-members': canChangeAddMembers
        'disabled': !canChangeAddMembers
      }) }, ->
        t.format 'invitations-permissions-ellipsis-invitationsdisplay', { invitationsDisplay }

    t.hr()

    t.li '.board-menu-navigation-item', ->
      t.a '.board-menu-navigation-item-link', { class: t.classify({
        'js-toggle-org-mem-join': canChangeSelfJoin && hasOrg && !isPrivate,
        'disabled': !canChangeSelfJoin || !hasOrg || isPrivate
      }) }, ->
        t.check selfJoin, 'allow-org-members-to-join'
        t.span '.sub-name', ->
          if hasOrg
            if isPrivate
              t.format 'any-organization-member-can-join-this-board-without-being-invited-to-enable-this-the-board-cant-be-private'
            else
              t.format 'any-organization-member-can-join-this-board-without-being-invited'
          else
            if isPrivate
              t.format 'any-organization-member-can-join-this-board-without-being-invited-to-enable-this-the-board-has-to-be-a-part-of-an-org-and-the-board-cant-be-private'
            else
              t.format 'any-organization-member-can-join-this-board-without-being-invited-to-enable-this-the-board-has-to-be-a-part-of-an-org'

    if canClose || canLeave
      t.hr()

      t.ul '.board-menu-navigation', ->

        if canClose
          t.li '.board-menu-navigation-item', ->
            t.a '.board-menu-navigation-item-link.js-close-board', { href: '#' }, ->
              t.format 'close-board-ellipsis'

        if canLeave
          t.li '.board-menu-navigation-item', ->
            t.a '.board-menu-navigation-item-link.js-leave-board', { href: '#' }, ->
              t.format 'leave-board-ellipsis'

    t.hr()

    t.div '.board-menu-navigation-item-block', ->
      t.label { for: 'id-short-url' }, ->
        t.format 'link-to-this-board'

      t.input '.js-short-url', { type: 'text', readonly: 'readonly', id: 'id-short-url', value: shortUrl }

      t.p '.quiet', ->
        t.span { class: 'icon-sm icon-' + pLevelClass, title: pLevelAltText }
        t.text helperText


module.exports = class BoardMenuSettingsAndMoreView extends View
  viewTitleKey: 'settings'
  viewIcon: 'gear'
  isTopLevelTab: true

  initialize: ({ @sidebarView }) ->
    @listenTo @model, 'change', @frameDebounce @render

  className: 'board-menu-content-frame'

  events:
    'click .js-open-collections': 'openCollections'
    'click .js-open-stickers': 'openStickers'
    'click .js-open-labels': 'openLabels'
    'click .js-open-archive': 'openArchivedItems'
    'click .js-share': 'shareBoard'
    'click .js-email': 'openEmailSettings'
    'click .js-board-subscribe': 'toggleSubscribe'
    'click .js-copy-board': 'copyBoard'
    'click .js-close-board': 'closeConfirm'
    'click .js-leave-board': 'leaveConfirm'
    'click .js-short-url': 'selectUrl'
    'click .js-change-background': 'changeBackground'
    'click .js-toggle-covers': 'toggleCovers'
    'click .js-change-comments': 'changeCommentingPerms'
    'click .js-change-add-members': 'changeAddMemberPerms'
    'click .js-toggle-org-mem-join': 'toggleSelfJoin'
    'click .js-change-org': 'changeOrg'

  render: (e) ->
    me = Auth.me()
    org = @model.getOrganization()

    @$el.html(template({
      canChangeAddMembers: @model.owned()
      canChangeBackground: @model.editable()
      canChangeCardCovers: @model.owned()
      canChangeComments: @model.owned()
      canChangeOrg: @model.owned()
      canChangeSelfJoin: @model.owned()
      canClose: @model.owned() || (org?.isFeatureEnabled('superAdmins') && org?.owned())
      canEmailToBoard: @model.editableByMember(me)
      canLeave: (@model.isMemberObserver(me) || @model.editableByMember(me)) && me.getMembershipData(@model).canRemove
      canRemoveOrg: org?.owned() && !@model.owned()
      cardCovers: @model.getPref('cardCovers')
      commentsDisplay: l(['board pref perms', @model.getCommentPerm()])
      hasOrg: org?
      helperText: l(['board perms', @model.getPermLevel(), 'short summary'])
      invitationsDisplay: l(['board pref perms', @model.getInvitePerm()])
      isPrivate: @model.isPrivate()
      loggedIn: Auth.isLoggedIn()
      orgDisplayName: org?.get('displayName')
      pLevelClass: BoardDisplayHelpers.getPermLevelIconClassForBoard(@model)
      pLevelAltText: BoardDisplayHelpers.getPermLevelAltTextForBoard(@model)
      selfJoin: @model.allowsSelfJoin()
      shortUrl: @model.get('shortUrl')
    }))

    @renderBackgroundPreview()

    @

  openCollections: (e) ->
    Util.stop(e)

    @sidebarView.pushView 'collections'
    track("Board Menu", "Open Board Collections", "Via Sidebar Menu")
    return

  openLabels: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'labels'
    track("Board Menu", "Open Labels")
    return

  openStickers: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'stickers'
    track("Board Menu", "Open Stickers", "Via More Menu")
    return

  openArchivedItems: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'archive'
    track("Board Menu", "Open Archived Items")
    return

  shareBoard: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @$(e.target).closest('.js-share')
      view: new SharePopoverView({ @model, @modelCache })

    track("Board Menu", "Open Share, Print, and Export Menu")

    return

  openEmailSettings: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @$(e.target).closest('.js-email')
      view: new EditEmailSettingsView({ @model, @modelCache })

    track('Board Menu', 'Open Email Settings - Menu')

    return

  copyBoard: (e) ->
    Util.stop(e)

    if !$(e.target).hasClass('disabled')
      track("Board Menu", "Open Copy Board")

      PopOver.toggle
        elem: @$(e.target).closest('.js-copy-board')
        view: new CreateBoardView({ @model, copyBoard: true, @modelCache })

    return

  toggleSubscribe: (e) ->
    Util.preventDefault(e)

    if !$(e.target).hasClass('disabled')
      @model.subscribe !@model.get('subscribed')
      track("Board Menu", "Subscribe/Unsubscribe")

    return

  closeConfirm: (e) ->
    Util.stop(e)
    track("Board Menu", "Open Close Menu")

    Confirm.toggle 'close board',
      elem: $(e.target).closest('a')
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.close()
        track("Board", "Close Board")

    return

  leaveConfirm: (e) ->
    Util.stop(e)
    track("Board Menu", "Open Leave Menu")

    me = Auth.me()
    key = me.removeMembershipConfirmationKey(@model)

    Confirm.toggle key,
      elem: $(e.target).closest('a')
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        @model.removeMember(me)
        track("Board", "Leave Board")

    return

  selectUrl: (e) ->
    @$('.js-short-url').focus().select()

  renderBackgroundPreview: ->
    $preview = @$('.js-fill-background-preview').css
      'background-image': ''
      'background-color': ''

    if Backgrounds[@model.getPref('background')]?.tile?
      backgroundImageUrl = @model.getPref('backgroundImage')
    else if @model.getPref('backgroundImageScaled')? || @model.getPref('backgroundImage')?
      backgroundImageUrl =
        Util.previewBetween(@model.getPref('backgroundImageScaled'), 90, 60, 600, 400)?.url ?
        @model.get('fullSizeUrl') ?
        @model.getPref('backgroundImage')

    else if @model.getPref('backgroundColor')?
      backgroundColor = @model.getClientBackgroundColor @model.getPref('background')
    else
      backgroundColor = @model.getClientBackgroundColor "blue"

    $preview.css
      'background-image': "url(#{backgroundImageUrl})"
      'background-color': backgroundColor

    @

  changeBackground: (e) ->
    Util.stop(e)
    @sidebarView.pushView 'background'
    track("Board Menu", "Open Change Background")
    return


  toggleCovers: (e, cardCovers) ->
    Util.stop(e)

    @model.setPref('cardCovers', !@model.getPref('cardCovers'))

    track("Board Menu", "Settings", "Enable/Disable Cover Images")
    return

  changeCommentingPerms: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: $(e.target).closest('a')
      view: new ChangeBoardCommentingPermsView({ @model, @modelCache })

    track("Board Menu", "Settings", "Open Change Commenting Permissions")

    return

  changeAddMemberPerms: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: $(e.target).closest('a')
      view: new ChangeBoardAddMemberPermsView({ @model, @modelCache })

    track("Board Menu", "Settings", "Open Change Add Member Permissions")

    return

  toggleSelfJoin: (e) ->
    Util.stop(e)

    @model.setPref('selfJoin', !@model.getPref('selfJoin'))
    @model.save()

    track("Board Menu", "Settings", "Toggle Allow Org Join")

    return

  changeOrg: (e) ->
    Util.stop(e)

    if @model.owned()

      PopOver.toggle
        elem: $(e.target).closest('a')
        view: BoardSelectOrganizationView
        options: { @model, @modelCache }

      track("Board Menu", "Settings", "Change Org")

    else
      idOrg = @model.get('idOrganization')
      @modelCache.get('Organization', idOrg)?.boardList.remove(@model)
      @model.update 'idOrganization', ''
      PopOver.hide()
      track("Board Menu", "Settings", "Remove Org")

    return



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-menu-settings-and-more-view.coffee